import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
type HeroProps = {
  onStart: () => void;
};
const markers = [{
  icon: '✨',
  label: 'Diagnóstico personalizado'
}, {
  icon: '⏱',
  label: 'Menos de 2 minutos'
}, {
  icon: '💚',
  label: 'Gratis y sin compromiso'
}];
const fadeUp = (delay: number) => ({
  initial: {
    opacity: 0,
    y: 18
  },
  animate: {
    opacity: 1,
    y: 0
  },
  transition: {
    duration: 1,
    delay,
    ease: [0.22, 1, 0.36, 1] as const
  }
});
export function Hero({
  onStart
}: HeroProps) {
  return <section className="relative min-h-[100svh] w-full bg-beige-50" data-id="element-43" data-mp="xb5szim1qzxu">
      <div className="mx-auto grid min-h-[100svh] w-full max-w-7xl grid-cols-1 lg:grid-cols-2" data-id="element-44" data-mp="sa9rfbp63pvl">
        {/* Imagen — compacta en móvil para que el CTA quede a la vista */}
        <div className="relative order-1 h-[26svh] min-h-[180px] w-full overflow-hidden sm:h-[34svh] lg:order-2 lg:h-auto lg:min-h-[100svh]" data-id="element-45" data-mp="3d1aa1ojbgjfe">
          <motion.img initial={{
          opacity: 0,
          scale: 1.06
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1.6,
          ease: [0.22, 1, 0.36, 1]
        }} src="https://cdn.magicpatterns.com/patterns/generated-images/215bf652-8901-4d85-b445-20d6bdf8d69e.jpg" alt="Piel saludable con luz natural junto a una ventana" className="h-full w-full object-cover object-center" data-id="element-46" data-mp="380vxpuaomnbk" />
          <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-beige-50 to-transparent lg:hidden" data-id="element-47" data-mp="30iazwxz9ckmf" />
        </div>

        {/* Contenido */}
        <div className="order-2 flex items-center px-6 pb-16 pt-10 sm:px-10 sm:pt-14 lg:order-1 lg:px-16 lg:py-24" data-id="element-48" data-mp="2qkwk90l5rzv6">
          <div className="w-full max-w-xl" data-id="element-49" data-mp="2vjg6z37ktfol">
            <motion.p {...fadeUp(0)} className="text-[0.68rem] uppercase tracking-[0.32em] text-sage-600" data-id="element-50" data-mp="2hj5clq725iyo">
              Diagnóstico facial · Skin Fresh Index™
            </motion.p>

            <motion.h1 {...fadeUp(0.08)} className="mt-6 font-serif text-[2.4rem] font-light leading-[1.05] tracking-tight text-warmgray-800 sm:text-5xl lg:text-[4rem]" data-id="element-51" data-mp="s2b89zesml5o">
              ¿Qué está necesitando
              <br className="hidden sm:block" data-id="element-52" data-mp="ia5i8v83qdt4" /> realmente tu piel?
            </motion.h1>

            <motion.p {...fadeUp(0.16)} className="mt-6 max-w-md text-base font-light leading-relaxed text-warmgray-600 sm:text-lg" data-id="element-53" data-mp="deyl669c87d6">
              Descubrilo en menos de 2 minutos y conocé qué tipo de piel tenés y
              qué rutina puede ayudarte a cuidarla sin comprar productos de más.
            </motion.p>

            <motion.ul {...fadeUp(0.24)} className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:gap-x-7 sm:gap-y-3" data-id="element-54" data-mp="x1w6u8q1wrhv">
              {markers.map(marker => <li key={marker.label} className="flex items-center gap-3 text-sm font-light text-warmgray-600" data-id="element-55" data-mp="3hqagchhnuxhc">
                  <span aria-hidden="true" className="text-base leading-none" data-id="element-56" data-mp="21amv97jfjola">
                    {marker.icon}
                  </span>
                  {marker.label}
                </li>)}
            </motion.ul>

            <motion.div {...fadeUp(0.32)} className="mt-10" data-id="element-57" data-mp="2b1r923xdd3ej">
              <motion.button type="button" onClick={onStart} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.99
            }} transition={{
              duration: 0.6,
              ease: [0.22, 1, 0.36, 1]
            }} className="group flex w-full items-center justify-center gap-3 rounded-full bg-sage-700 px-10 py-6 text-sm uppercase tracking-[0.18em] text-beige-50 transition-colors duration-700 ease-calm hover:bg-sage-800 sm:w-auto sm:px-14" data-id="element-58" data-mp="2fzsqylj26wof">
                Quiero descubrir mi rutina
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-700 ease-calm group-hover:translate-x-1" strokeWidth={1.25} data-id="element-59" data-mp="zm2kx98dpyc5" />
              </motion.button>

              <p className="mt-6 max-w-sm text-xs font-light leading-relaxed text-warmgray-400" data-id="element-60" data-mp="3vk1ijwwclywp">
                Respondé unas preguntas sobre tu piel y al final vas a recibir
                una recomendación personalizada.
              </p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}